<template>
    <div style="width: 99%; display: block; padding: 5px; margin-left: auto; margin-right: auto;">

        <b-modal id="modal-po-items" @hide="fetch_orders" scrollable title="LOW INVENTORY PO ITEMS" size="xl" hide-footer style="min-height: 700px;">
            <LowInventoryPOItems v-on:done-items-po="close_po_items" style="min-height: 700px;" :viewdata="{low_inventory_po_id: low_inventory_po_id, low_inventory_po_vendor_id: low_inventory_po_vendor_id}" />
        </b-modal>

        <div style="display: block; margin-top: 10px;">
            <div
              v-if="isMobile"
              class="d-flex justify-content-between align-items-center mb-2 px-1"
            >
              <b-button
                size="sm"
                variant="outline-primary"
                @click="filtersVisible = !filtersVisible"
              >
                <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
              </b-button>
            </div>

            <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
              <b-alert variant="secondary" show>
                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>ETA</div>
                  <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                  ></date-picker>
                </div>

                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>STATUS</div>
                  <b-form-select :options="statuses" v-model="status"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>VENDOR</div>
                  <b-form-select :options="packet.vendors" v-model="vendor"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>RECEIVING LOC</div>
                  <b-form-select :options="filter_receiving_locations" v-model="receiving_loc_filter"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>SHIPPING LOC</div>
                  <b-form-select :options="filter_locations" v-model="ship_to_filter"></b-form-select>
                </div>

                <div style="width: 200px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>ITEM SEARCH</div>
                  <b-form-input
                    v-model="itemSearch"
                    placeholder="Search products..."
                    style="width: 280px; font-size: 14px;"
                    debounce="300"
                  ></b-form-input>
                </div>
              </b-alert>
            </b-collapse>

            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="true">
                    </loading>
                </div>

                <div v-else>
                    <div v-if="items.length == 0">
                        <b-alert show variant="warning"> NO LOW INVENTORY POS </b-alert>
                    </div>
                    <div v-else>
                        <div class="diver">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="srr" style="width: 150px; background-color: lightyellow;">PO #</th>
                                        <th class="srr" style="width: 150px; background-color: lightyellow;">VENDOR</th>
                                        <th class="srr" style="width: 120px; background-color: lightyellow;">STATUS</th>
                                        <th class="srr" style="width: 130px; background-color: lightyellow">ETA</th>
                                        <th class="srr" style="width: 120px; background-color: lightblue">TOTAL ITEMS</th>
                                        <th class="srr" style="width: 120px; background-color: lightblue">TOTAL COST</th>
                                        <th class="srr" style="width: 150px; background-color: lightblue">SHIPPING LOCATION</th>
                                        <th class="srr" style="width: 150px; background-color: lightblue">BILLING LOCATION</th>
                                        <th class="srr" style="width: 150px; background-color: lightblue">RECEIVING LOCATION</th>
                                        <th class="srr" style="width: 180px; background-color: lightblue">CREATED BY</th>
                                        <th class="srr" style="width: 130px; background-color: lightblue">CREATED DATE</th>
                                        <th class="srr" style="width: 60px;">
                                            <b-button
                                                size="sm"
                                                @click="isDetailsExpanded = !isDetailsExpanded"
                                                variant="outline-primary"
                                                :disabled="packet.userDetails.userrole === 'warehouseuser'">
                                                {{ isDetailsExpanded ? 'HIDE' : 'SHOW' }}
                                            </b-button>
                                        </th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 150px; background-color: lightgreen;">VENDOR SKU</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 150px; background-color: lightgreen;">PRODUCT SKU</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 250px; background-color: lightgreen;">PRODUCT NAME</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px; background-color: lightgreen;">QUANTITY ORDERED</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px; background-color: lightgreen;">UNIT COST</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px; background-color: lightgreen;">TOTAL COST</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px; background-color: lightgreen;">CURRENT STOCK</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px; background-color: lightgreen;">AVAILABLE STOCK</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px; background-color: lightgreen;">RESERVED STOCK</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 150px; background-color: lightgreen;">CATEGORY</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px; background-color: lightgreen;">ITEM STATUS</th>
                                        <th class="srr">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item,idx in filteredItems" v-bind:key="idx">
                                        <td class="srrv">
                                            {{item.po_number}}
                                        </td>
                                        <td class="srrv">
                                            {{vendorsDict[item.vendor_id]}}
                                        </td>
                                        <td class="srrv">
                                            <b-form-select
                                                :options="getStatusOptions(item)"
                                                v-model="item.status"
                                                size="sm"
                                                :disabled="isItemDisabled2(item)"
                                            ></b-form-select>
                                        </td>
                                        <td class="srrv">
                                            <date-picker
                                                v-model="item.eta"
                                                format="MM-DD-YYYY"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 110px; font-size: 11px;"
                                                @change="handleETADateChange(item)"
                                            ></date-picker>
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            {{item.total_items}}
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            ${{parseFloat(item.total_cost).toFixed(2)}}
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            <b-form-select
                                                size="sm"
                                                :options="filteredShipToLocations"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                v-model="item.shipping_location_id"
                                                @change="handleLocationChange(item, 'shipping_location_id')"
                                            ></b-form-select>
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            <b-form-select
                                                size="sm"
                                                :options="filteredBillToLocations"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                v-model="item.billing_location_id"
                                                @change="handleLocationChange(item, 'billing_location_id')"
                                            ></b-form-select>
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            <b-form-select
                                                size="sm"
                                                :options="filteredReceivingLocations(item)"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                v-model="item.receiving_location_id"
                                            ></b-form-select>
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            {{item.created_by}}
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            {{formatDate(item.created_at)}}
                                        </td>
                                        <td class="srrv"></td>
                                        
                                        <!-- Expanded Details -->
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <button v-if="item.po_items && item.po_items.length > 0" @click="item.showDetails = false">HIDE</button>
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">
                                                        {{ p.vendor_sku || 'N/A' }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">
                                                        {{ p.product_sku }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">
                                                        {{ p.product_name }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 13px;">
                                                        {{ p.quantity_ordered }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 13px;">
                                                        ${{ parseFloat(p.unit_cost).toFixed(2) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 13px;">
                                                        ${{ parseFloat(p.total_cost).toFixed(2) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 13px;">
                                                        {{ p.current_stock }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 13px;">
                                                        {{ p.available_stock }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 13px;">
                                                        {{ p.reserved_stock }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">
                                                        {{ p.category }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>
                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background-color: #DEEED8;">
                                            <div v-if="item.showDetails">
                                                <div v-for="(p, pidx) in item.po_items" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">
                                                        {{ p.status }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!(item.po_items && item.po_items.length > 0)">
                                                    SHOW {{ (item.po_items || []).length }} ITEMS
                                                </button>
                                            </div>
                                        </td>

                                        <td class="srrv">
                                            <div style="display: inline-block;">
                                                <b-button size="sm" variant="outline-success"
                                                    @click="view_item(item)" v-b-tooltip.hover title="VIEW ITEMS">
                                                    <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>

                                            <div style="display: inline-block;">
                                                <b-button size="sm"
                                                    v-if="packet.userDetails.userrole == 'admin'"
                                                    variant="outline-primary" @click="update_low_inventory_po(item)" v-b-tooltip.hover title="SAVE">
                                                    <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>
                                            
                                            <div style="display: inline-block;">
                                                <b-button
                                                    size="sm"
                                                    variant="outline-danger"
                                                    v-if="packet.userDetails.userrole == 'admin'"
                                                    @click="delete_order(item)"
                                                    v-b-tooltip.hover
                                                    :title="item.status === 'ARCHIVED' ? 'DELETE ORDER' : 'Only archived orders can be deleted'"
                                                    :disabled="item.status !== 'ARCHIVED'"
                                                >
                                                    <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import LowInventoryPOItems from "@/components/VendorOrders/LowInventoryPOItems"
    import { BIconFunnelFill } from 'bootstrap-vue'

    export default {
        name: "ListLowInventoryPO",
        props: [],
        components: { Loading, DatePicker, LowInventoryPOItems },
        data: function(){
            return {
                packet: {},
                items: [],
                isDetailsExpanded: false,
                items_being_loaded: null,
                statuses: [
                    {value: "open", text: "OPEN"},
                    {value: "NEW", text: "NEW"},
                    {value: "ORDERED", text: "ORDERED"},
                    {value: "SCHEDULED", text: "SCHEDULED"},
                    {value: "IN_TRANSIT", text: "IN-TRANSIT"},
                    {value: "PARTIAL", text: "PARTIAL"},
                    {value: "RECEIVED", text: "RECEIVED"},
                    {value: "COMPLETED", text: "COMPLETED"},
                    {value: "ARCHIVED", text: "ARCHIVED"},
                ],
                low_inventory_po_id: null,
                low_inventory_po_vendor_id: null,
                // Filters
                status: "open",
                vendor: null,
                date_range: [],
                ship_to_filter: null,
                receiving_loc_filter: null,
                itemSearch: '',
                // Location options
                locations: [],
                receiving_locations: [],
                filter_locations: [],
                filter_receiving_locations: [],
                filtersVisible: false,
                isMobile: false,
            };
        },
        mounted() {
            this.handleResize()
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            vendorsDict() {
                const dict = {};
                this.packet.vendors.forEach(vendor => {
                    if (vendor.value) {
                        dict[vendor.value] = vendor.text;
                    }
                });
                return dict;
            },
            filteredShipToLocations() {
                const excludedShipTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let shipToLocations = allLocations
                    .filter(loc => !excludedShipTo.includes(loc.text))
                    .map(this.replaceMecca);

                const warehouseLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                shipToLocations = shipToLocations.filter(loc =>
                    !warehouseLocations.some(wh => loc.text.includes(wh))
                );

                const meccaOption = { value: 47, text: 'MECCA WHOLESALE', isMecca: true };
                shipToLocations.unshift(meccaOption);

                return shipToLocations;
            },
            filteredBillToLocations() {
                const excludedBillTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', '9TH ST ', '101 WH', 'FOLCROFT'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let billToLocations = allLocations
                    .filter(loc => !excludedBillTo.includes(loc.text))
                    .map(this.replaceMecca);

                const meccaWholesaleOption = { value: 47, text: 'MECCA WHOLESALE', isMecca: true };
                billToLocations = billToLocations.filter(loc => loc.text !== 'MECCA WHOLESALE');
                billToLocations.unshift(meccaWholesaleOption);

                return billToLocations;
            },
            filteredReceivingLocations: function() {
                return function(item) {
                    const shipToLocation = item.shipping_location_id;

                    if (!shipToLocation) {
                        return this.receiving_locations;
                    }

                    const shipToText = this.getLocationText(shipToLocation);

                    if (shipToText === 'MECCA WHOLESALE') {
                        return this.receiving_locations.filter(loc => {
                            const locText = loc.text.toUpperCase().trim();
                            return locText === '9TH ST' ||
                                   locText === '101 WH' ||
                                   locText === 'FOLCROFT' ||
                                   locText.includes('9TH ST') ||
                                   locText.includes('101 WH') ||
                                   locText.includes('FOLCROFT');
                        });
                    } else {
                        return this.receiving_locations.filter(loc =>
                            loc.value == shipToLocation || loc.text === shipToText
                        );
                    }
                };
            },
            filteredItems: function() {
                let that = this;
                return that.items.filter(d => {
                    return (
                        ((that.vendor) ? d.vendor_id == that.vendor : true) &&
                        (that.status !== null && that.status !== undefined
                            ? (that.status == "open"
                                ? ['NEW','ORDERED','SCHEDULED','IN_TRANSIT','PARTIAL'].includes(d.status)
                                : d.status == that.status
                              )
                            : true
                        ) &&
                        (this.date_range.length === 2 && !this.date_range.includes(null)
                            ? moment(d.eta).isSameOrAfter(moment(this.date_range[0]), 'day') &&
                              moment(d.eta).isSameOrBefore(moment(this.date_range[1]), 'day')
                            : true
                        ) &&
                        ((that.receiving_loc_filter) ? d.receiving_location_id == that.receiving_loc_filter : true) &&
                        ((that.ship_to_filter) ? d.shipping_location_id == that.ship_to_filter : true) &&
                        ((that.itemSearch) ?
                            d.po_items.some(item =>
                                item.product_name.toLowerCase().includes(that.itemSearch.toLowerCase()) ||
                                item.product_sku.toLowerCase().includes(that.itemSearch.toLowerCase())
                            ) : true
                        )
                    );
                });
            }
        },
        methods: {
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
            replaceMecca: function(location) {
                if (location.text === '9th ST, 101 WH, FOLCROFT') {
                    return { ...location, text: 'MECCA WHOLESALE' };
                }
                return location;
            },
            getLocationText: function(locationValue) {
                if (locationValue === 0 || locationValue === '0' || locationValue === 47) {
                    return 'MECCA WHOLESALE';
                }

                const normalizeText = (text) => text.toUpperCase().trim();

                const billToLoc = this.filteredBillToLocations.find(loc => loc.value == locationValue);
                if (billToLoc) return normalizeText(billToLoc.text);

                const shipToLoc = this.filteredShipToLocations.find(loc => loc.value == locationValue);
                if (shipToLoc) return normalizeText(shipToLoc.text);

                const allLoc = this.packet.locations.find(loc => loc.value == locationValue);
                return allLoc ? normalizeText(allLoc.text) : '';
            },
            isItemDisabled(item) {
                const completedStatuses = ['RECEIVED', 'COMPLETED', 'ARCHIVED'];
                if (this.packet.userDetails.userrole === 'warehouseuser') {
                    return true;
                }
                if (completedStatuses.includes(item.status)) {
                    return true;
                }
                return false;
            },
            isItemDisabled2(item) {
                const completedStatuses = ['COMPLETED', 'ARCHIVED'];
                if (this.packet.userDetails.userrole !== 'admin') {
                    return true;
                }
                if (completedStatuses.includes(item.status)) {
                    return true;
                }
                return false;
            },
            getStatusOptions: function(item) {
                const currentStatus = item.status;
                const statusOptions = this.statuses.filter(s => s.value !== "open");
                
                return statusOptions.map(status => {
                    let disabled = false;

                    if (['RECEIVED', 'COMPLETED', 'ARCHIVED'].includes(currentStatus)) {
                        disabled = true;
                    } else if (currentStatus === 'NEW') {
                        disabled = !['NEW', 'ORDERED', 'SCHEDULED'].includes(status.value);
                    } else if (currentStatus === 'ORDERED') {
                        disabled = !['ORDERED', 'SCHEDULED', 'IN_TRANSIT'].includes(status.value);
                    } else if (currentStatus === 'SCHEDULED') {
                        disabled = !['SCHEDULED', 'IN_TRANSIT'].includes(status.value);
                    } else if (currentStatus === 'IN_TRANSIT') {
                        disabled = !['SCHEDULED', 'IN_TRANSIT'].includes(status.value);
                    } else if (currentStatus === 'PARTIAL') {
                        disabled = !['RECEIVED', 'COMPLETED', 'ARCHIVED'].includes(status.value);
                    }

                    return {
                        ...status,
                        disabled: disabled
                    };
                });
            },
            handleLocationChange: function(item, field) {
                if (field === 'shipping_location_id') {
                    this.handleShipToChange(item, field);
                }
            },
            handleShipToChange: function(item, field) {
                const shipToLocation = item.shipping_location_id;
                item.receiving_location_id = null;

                if (shipToLocation && shipToLocation !== '0' && shipToLocation !== 47) {
                    item.receiving_location_id = shipToLocation;
                }
            },
            handleETADateChange(item) {
                console.log('ETA date changed for item:', item);
            },
            delete_order: function(item){
                if (!item.id){
                    this.$vex.dialog.alert(
                        {message: "PLEASE SAVE THE ORDER FIRST BEFORE DELETING IT."}
                    );
                    return
                }
                let data = {id: item.id};
                let that = this;
                let path = "/api/sales/delete_low_inventory_po/"

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "ERROR", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "DELETED",
                            {title: "SUCCESS", autoHideDelay: 1500, variant:"success"}
                        );
                        that.items=that.items.filter(function(d){return d.id != item.id});
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in deleting. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            formatDate(dateStr) {
                if (!dateStr) return "";
                let dateObj;
                if (dateStr.includes('GMT')) {
                    dateObj = new Date(dateStr);
                } else {
                    dateObj = new Date(dateStr);
                }
                const day = String(dateObj.getDate()).padStart(2, "0");
                const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                const year = dateObj.getFullYear();
                return `${day}-${month}-${year}`;
            },
            validate: function(item) {
                let errors = [];

                if (!item.receiving_location_id) {
                    errors.push({message: "PLEASE INDICATE A RECEIVING LOCATION."})
                    return errors;
                }

                const shipToText = this.getLocationText(item.shipping_location_id);
                const receivingText = this.getLocationText(item.receiving_location_id);

                if (shipToText === 'MECCA WHOLESALE') {
                    const isWarehouseLocation =
                        receivingText.includes('9TH ST') ||
                        receivingText.includes('101 WH') ||
                        receivingText.includes('FOLCROFT');

                    if (!isWarehouseLocation) {
                        errors.push({ message: "For Mecca Wholesale shipping, receiving location must be 9th ST, 101 WH, or FOLCROFT." });
                    }
                } else {
                    if (shipToText !== receivingText) {
                        errors.push({ message: `Receiving location (${receivingText}) must match shipping location (${shipToText}).` });
                    }
                }

                return errors;
            },
            update_low_inventory_po: function(item) {
                let that = this;
                console.log('=== SAVE DEBUG ===');
                console.log('Item being saved:', item);

                let errors = this.validate(item);
                if (errors.length > 0) {
                    this.$vex.dialog.alert(
                        {message: errors[0].message}
                    );
                    return;
                }

                const payload = {
                    id: item.id,
                    data: {
                        status: item.status,
                        receiving_location_id: item.receiving_location_id,
                        billing_location_id: item.billing_location_id,
                        shipping_location_id: item.shipping_location_id,
                        eta: item.eta,
                    }
                };

                let path = "/api/sales/update_low_inventory_po/";
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "SAVED",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                };

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred in saving. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                };
                Requestor.postSyncP(path, payload, this, s, f);
            },
            fetch_orders: function() {
                let userRole = this.packet.userDetails.userrole;

                let data = {
                    status: this.status,
                    location_id: this.packet.userDetails.properties.location_id,
                    userRole: userRole
                };

                let that = this;
                let path = "/api/sales/get_low_inventory_pos/"

                let s = function(response) {
                    if (response.data.result) {
                        let res = response.data.result;
                        console.log('Raw API response:', res);

                        that.items = Array.isArray(res) ? res.map(item => {
                            return {
                                ...item,
                                eta: item.eta ? moment(item.eta).format('MM-DD-YYYY') : null,
                                showDetails: false,
                                shipping_location_id: item.shipping_location_id !== null ? Number(item.shipping_location_id) : null,
                                billing_location_id: item.billing_location_id !== null ? Number(item.billing_location_id) : null,
                                receiving_location_id: item.receiving_location_id !== null ? Number(item.receiving_location_id) : null,
                            }
                        }) : [];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }

                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            view_item(item) {
                this.low_inventory_po_id = item.id;
                this.low_inventory_po_vendor_id = item.vendor_id;
                this.$bvModal.show("modal-po-items");
            },
            close_po_items: function() {
                this.$bvModal.hide("modal-po-items");
                this.fetch_orders()
            },
            setupLocations: function() {
                const allLocations = this.packet.locations.filter(d => 
                    d && d.text && d.text != 'All' && d.value != null
                );
                
                const excludedLocationTexts = ['ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];

                this.locations = allLocations
                    .filter(location => location.text && !excludedLocationTexts.includes(location.text))
                    .map(this.replaceMecca);

                this.receiving_locations = allLocations
                    .filter(loc => {
                        if (!loc.text) return false;
                        const locText = loc.text.toUpperCase();
                        return !excludedLocationTexts.some(excluded =>
                            locText.includes(excluded.toUpperCase())
                        );
                    })
                    .map(this.replaceMecca);

                this.filter_locations = [
                    { value: null, text: 'ALL' },
                    ...this.locations
                ];

                this.filter_receiving_locations = [
                    { value: null, text: 'ALL' },
                    ...this.receiving_locations
                ];
            }
        },
        created() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.vendors.splice(0, 0, {value: null, text: "ALL"});
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.setupLocations();
            this.fetch_orders();
        }
    }
</script>

<style scoped>
    .diver {
      overflow:auto;
      width:100%;
      height:600px;
    }
    td,
    th {
      border: 1px solid;
      width: 300px;
    }
    th {background-color:white;}

    table {
      table-layout: fixed;
      width:100%;
    }
    td:first-child, th:first-child {
      position:sticky;
      left:0;
      z-index:1;
      background-color: white;
    }

    td:last-child, th:last-child {
      position:sticky;
      right:0;
      z-index:1;
      background-color:white;
      width: 150px;
    }
    thead tr th {
      position:sticky;
      top:0;
    }
    th:first-child, th:last-child {
        z-index:2;background-color:white;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

.box {
    padding: 3px;
    text-align: center;
    margin: 5px;
    background: #c8e6c9;
    color: black;
    border: 1px solid black;
}

    @media (max-width: 768px) {
        td:first-child,
        th:first-child,
        td:last-child,
        th:last-child,
        thead tr th {
            position: static !important;
            left: auto !important;
            right: auto !important;
            top: auto !important;
            z-index: auto !important;
        }

        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/ListLowInventoryPO.vue